import { render, staticRenderFns } from "./ApplicantsComplete.vue?vue&type=template&id=445bc2d6&"
import script from "./ApplicantsComplete.vue?vue&type=script&lang=js&"
export * from "./ApplicantsComplete.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantsComplete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VAlert,VBtn,VCheckbox,VDataTable,VIcon,VRating})
